import { defineStore } from "pinia";
import { computed, reactive, ref } from "vue";
import { sendConfiguratorEvent } from '../common/event-tracking';
import { useConfiguratorStore } from './configurator';

export const useSubmitStore = defineStore("submit", () => {
    const configurationStore = useConfiguratorStore();

    const isLoading = ref(false);
    const error = ref(null);
    const isFinished = ref(false);

    const activePartnerId = ref(null);

    const contactDealer = ref(false);
    const altcha = ref('');
    const formData = reactive({
        amountOfDoors: null,
        email: null,
        terms: null,
        firstname: null,
        lastname: null,
        zip: null,
        city: null,
        country: null,
        phone: null,
    });

    const canSubmit = computed(() => {
        return (
            altcha.value.length > 0 &&
            !configurationStore.isImageLoading &&
            !isLoading.value &&
            formData.email &&
            formData.terms &&
            (!contactDealer.value ||
                (formData.amountOfDoors &&
                    formData.firstname &&
                    formData.lastname &&
                    formData.city &&
                    formData.zip &&
                    formData.country &&
                    formData.phone)
                )
        );
    });

    async function submit() {
        try {
            sendConfiguratorEvent("submit_form", contactDealer.value ? "kontaktieren" : "speichern");

            if (isLoading.value) {
                return;
            }

            isLoading.value = true;

            const response = await fetch("/configurator/submit", {
                method: "POST",
                body: JSON.stringify({
                    partnerId: activePartnerId.value,
                    configuration: configurationStore.jsonSerializedConfiguration,
                    contactDealer: contactDealer.value,
                    hash: configurationStore.configHash,
                    contact: formData,
                    altcha: altcha.value,
                })
            });

            const json = await response.json();

            if (json.success) {
                configurationStore.configHash = json.data.hash;
                error.value = null;
                isFinished.value = true;
            } else if (json.error) {
                error.value = json.error;
            }
        } catch (error) {
            error.value = "Service unavailable";
        }

        isLoading.value = false;
    }

    return {
        isLoading,
        error,
        isFinished,
        canSubmit,
        activePartnerId,
        contactDealer,
        formData,
        altcha,
        submit,
    };
});
